<template>
  <div class="seal-nav-page">
    <van-nav-bar title="印章工具" />

    <div class="content-wrapper">
      <p class="page-desc">请选择要进入的功能（需后管账号登录）</p>

      <van-button
        type="primary"
        size="large"
        block
        round
        class="nav-btn"
        @click="goTo('/sealPointsInput')"
      >
        录入印章点位
      </van-button>

      <van-button
        type="info"
        size="large"
        block
        round
        class="nav-btn"
        @click="goTo('/sealTest')"
      >
        印章相似度测试
      </van-button>

      <van-button
        plain
        type="primary"
        size="large"
        block
        round
        class="nav-btn"
        @click="goTo('/sealTouchDetect')"
      >
        印章触点检测（纯前端）
      </van-button>

      <van-button
        plain
        type="default"
        size="large"
        block
        round
        class="nav-btn"
        @click="goAdmin"
      >
        进入后管首页
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SealNav',
  methods: {
    goTo(path) {
      this.$router.push(path)
    },
    goAdmin() {
      this.$router.push('/admin/home')
    }
  }
}
</script>

<style scoped lang="less">
.seal-nav-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.content-wrapper {
  padding: 24px 16px;
}

.page-desc {
  margin: 0 0 24px;
  font-size: 14px;
  color: #666;
  text-align: center;
}

.nav-btn {
  margin-bottom: 16px;
}
</style>
